// source: tableau/metrics/models/metric_configuration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

var tableau_metrics_models_threshold_pb = require('../../../tableau/metrics/models/threshold_pb.js');
goog.object.extend(proto, tableau_metrics_models_threshold_pb);
var tableau_metrics_models_date_window_pb = require('../../../tableau/metrics/models/date_window_pb.js');
goog.object.extend(proto, tableau_metrics_models_date_window_pb);
goog.exportSymbol('proto.tableau.metrics.models.p4.MetricConfiguration', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.MetricConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tableau.metrics.models.p4.MetricConfiguration.repeatedFields_, null);
};
goog.inherits(proto.tableau.metrics.models.p4.MetricConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.MetricConfiguration.displayName = 'proto.tableau.metrics.models.p4.MetricConfiguration';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tableau.metrics.models.p4.MetricConfiguration.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.MetricConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.MetricConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.MetricConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    thresholdsList: jspb.Message.toObjectList(msg.getThresholdsList(),
    tableau_metrics_models_threshold_pb.Threshold.toObject, includeInstance),
    dateWindowList: jspb.Message.toObjectList(msg.getDateWindowList(),
    tableau_metrics_models_date_window_pb.DateWindow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.MetricConfiguration;
  return proto.tableau.metrics.models.p4.MetricConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.MetricConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new tableau_metrics_models_threshold_pb.Threshold;
      reader.readMessage(value,tableau_metrics_models_threshold_pb.Threshold.deserializeBinaryFromReader);
      msg.addThresholds(value);
      break;
    case 2:
      var value = new tableau_metrics_models_date_window_pb.DateWindow;
      reader.readMessage(value,tableau_metrics_models_date_window_pb.DateWindow.deserializeBinaryFromReader);
      msg.addDateWindow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.MetricConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.MetricConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.MetricConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThresholdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      tableau_metrics_models_threshold_pb.Threshold.serializeBinaryToWriter
    );
  }
  f = message.getDateWindowList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      tableau_metrics_models_date_window_pb.DateWindow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Threshold thresholds = 1;
 * @return {!Array<!proto.tableau.metrics.models.p4.Threshold>}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.getThresholdsList = function() {
  return /** @type{!Array<!proto.tableau.metrics.models.p4.Threshold>} */ (
    jspb.Message.getRepeatedWrapperField(this, tableau_metrics_models_threshold_pb.Threshold, 1));
};


/**
 * @param {!Array<!proto.tableau.metrics.models.p4.Threshold>} value
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration} returns this
*/
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.setThresholdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tableau.metrics.models.p4.Threshold=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tableau.metrics.models.p4.Threshold}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.addThresholds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tableau.metrics.models.p4.Threshold, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration} returns this
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.clearThresholdsList = function() {
  return this.setThresholdsList([]);
};


/**
 * repeated DateWindow date_window = 2;
 * @return {!Array<!proto.tableau.metrics.models.p4.DateWindow>}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.getDateWindowList = function() {
  return /** @type{!Array<!proto.tableau.metrics.models.p4.DateWindow>} */ (
    jspb.Message.getRepeatedWrapperField(this, tableau_metrics_models_date_window_pb.DateWindow, 2));
};


/**
 * @param {!Array<!proto.tableau.metrics.models.p4.DateWindow>} value
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration} returns this
*/
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.setDateWindowList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tableau.metrics.models.p4.DateWindow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tableau.metrics.models.p4.DateWindow}
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.addDateWindow = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tableau.metrics.models.p4.DateWindow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tableau.metrics.models.p4.MetricConfiguration} returns this
 */
proto.tableau.metrics.models.p4.MetricConfiguration.prototype.clearDateWindowList = function() {
  return this.setDateWindowList([]);
};


goog.object.extend(exports, proto.tableau.metrics.models.p4);
